import { useEffect, useState } from 'react';
/**
 * Reactive media query hook. Returns whether the current viewport matches `query`.
 * Re-renders the calling component when the match state flips (e.g. user resizes
 * the window across a breakpoint).
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined')
            return false;
        return window.matchMedia(query).matches;
    });
    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        mql.addEventListener('change', onChange);
        setMatches(mql.matches);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);
    return matches;
}
